document.addEventListener('DOMContentLoaded', function () {
  const wishlistCount = document.querySelector('.wishlist-total-count');
  const cartDot = document.querySelector('span.header__cart-dot');

  // const updateWishlistButton = () => {
  //   const wishlistPage = document.querySelector('.wishlist-page');
  //   if (wishlistPage) {
  //     const observer = new MutationObserver(() => {
  //       const buttons = wishlistPage.querySelectorAll('.wishlist-move-cart');
  //       buttons.forEach((button) => {
  //         if (window.location.href.includes('pl')) {
  //           button.textContent = 'Dodaj do koszyka';
  //         }
  //       });
  //     });

  //     observer.observe(wishlistPage, { childList: true, subtree: true });
  //   }
  // };

  // updateWishlistButton();
  /**
   *
   */
  function updateCartDotVisibility() {
    if (wishlistCount && cartDot) {
      if (parseInt(wishlistCount.getAttribute('data-total'), 10) > 0) {
        cartDot.classList.add('is-visible');
      } else {
        cartDot.classList.remove('is-visible');
      }
    }
  }

  updateCartDotVisibility();

  const observer = new MutationObserver(updateCartDotVisibility);
  if (wishlistCount) {
    observer.observe(wishlistCount, { attributes: true, attributeFilter: ['data-total'] });
  }
});
